module.exports = __webpack_public_path__ + "img/logo.e2ef016e.png";